var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video-item",attrs:{"src":_vm.link,"preload":"none","controls":"","poster":_vm.poster}})}
var staticRenderFns = []

export { render, staticRenderFns }